<main class="main" id="top">
    <div class="container-fluid p-4">
        <html>

        <head>
            <link href="https://fonts.googleapis.com/css?family=Nunito+Sans:400,400i,700,900&display=swap"
                rel="stylesheet">
        </head>
        <style>
            body {
                text-align: center;
                padding: 40px 0;
                background: #EBF0F5;
            }

            h1 {
                color: #88B04B;
                font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
                font-weight: 900;
                font-size: 40px;
                margin-bottom: 10px;
            }

            p {
                color: #404F5E;
                font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
                font-size: 20px;
                margin: 0;
            }

            i {
                color: #9ABC66;
                font-size: 100px;
                line-height: 200px;
                margin-left: -15px;
            }

            .card {
                background: white;
                padding: 60px;
                border-radius: 4px;
                box-shadow: 0 2px 3px #C8D0D8;
                display: inline-block;
                margin: 0 auto;
            }
        </style>

        <body>
            <div class="card">
                <div style="border-radius:200px; height:200px; width:200px; background: #F8FAF5; margin:0 auto;">
                    <i class="checkmark">✓</i>
                </div>
                <h1>Success</h1>
                <p>Payment done successfully<br /> Thank you!!</p>
                <div class="text-center m-4">
                    <button class="btn btn-block btn-success" (click)="printAndOpenReceipt()">Print Receipt</button>
                </div>
                <div class="text-center m-4" *ngIf="currentUserDetails.userType == 'CLIENT'">
                    <button class="btn btn-block btn-success" routerLink="/pages/dashboard"
                        routerLinkActive="router-link-active">Go to Dashboard</button>
                </div>
                <div class="text-center m-4" *ngIf="currentUserDetails.userType != 'CLIENT'">
                    <button class="btn btn-block btn-success" routerLink="/pages/customer/customer-dashboard"
                        routerLinkActive="router-link-active">Continue Shopping</button>
                </div>
            </div>

        </body>

        </html>
    </div>
</main>